import { defineStore } from "pinia";
import apiClient from "@/service/api"; 
// Import du service individuel pour la création
import { individuelService } from "@/service/api"; 

export const useAuthStore = defineStore("auth", {
  state: () => ({
    currentUser: JSON.parse(localStorage.getItem('user')) || null,
    token: localStorage.getItem('token') || null,
    loading: false,
    error: null
  }),

 getters: {
    loggedIn: (state) => !!state.token,
    
    // Vérification par le champ 'name' pour chaque profil
    isAdmin: (state) => state.currentUser?.role?.name === 'ADMIN',
    isIndividuel: (state) => state.currentUser?.role?.name === 'INDIVIDUEL',
    isPartenaire: (state) => state.currentUser?.role?.name === 'RESPONSABLE_PARTENAIRE',

    // Optionnel : un getter qui retourne directement le nom du rôle pour simplifier
    userRole: (state) => state.currentUser?.role?.name || null
  },

  

  actions: {
    /**
     * Action pour créer un compte Individu
     */
    async register(payload) {
      this.loading = true;
      this.error = null;
      try {
        // Utilisation du service que nous avons configuré ensemble
        const response = await individuelService.create(payload);
        return response.data;
      } catch (error) {
        this.error = error.response?.data?.message || "Erreur lors de l'inscription";
        throw error;
      } finally {
        this.loading = false;
      }
    },

    async login(credentials) {
      this.loading = true;
      this.error = null;
      try {
        const response = await apiClient.post('/login', credentials);
        
        this.token = response.data.access_token;
        localStorage.setItem('token', this.token);

        return await this.fetchUser();
        
      } catch (error) {
        this.error = error.response?.data?.message || "Erreur de connexion";
        throw error;
      } finally {
        this.loading = false;
      }
    },

    async fetchUser() {
      try {
        const response = await apiClient.get('/me');
        const userData = response.data;

        this.currentUser = userData;
        localStorage.setItem('user', JSON.stringify(userData));

        return userData;
      } catch (error) {
        this.logOut();
        throw error;
      }
    },

    logOut() {
      this.token = null;
      this.currentUser = null;
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      return true;
    }
  },
});